export enum BatteryStates {
    Low = 'LOW_BATTERY',
}
